define('views/comments/comment-form',[
  "../abstract-comments/create-form"
], function (AbstractCommentFormView) {
  "use strict";

  return AbstractCommentFormView.extend({
    serialize: function () {
      return _.extend(AbstractCommentFormView.prototype.serialize.call(this), {
        status: this.$("[name = status]").val(),
        severity: this.$("[name = severity]").val(),
        attachment: this.$("[name = attachment]").val(),
        highlight: this.$("[name = highlight]").val()
      });
    }
  });
});

